import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ClientITProfile, Project } from 'src/app/_models';
import { Integration } from '../../_models/integration';
import { AlertService, IntegrationsService } from '../../_services';
import { EditIntegrationAppComponent } from '../edit-integration-app/edit-integration-app.component';

@Component({
    standalone: false,
  selector: 'integration-apps',
  templateUrl: './integration-apps.component.html',
  styleUrls: ['./integration-apps.component.css'],
  providers: [DialogService],
})
export class IntegrationAppsComponent implements OnInit, OnDestroy {
  @Input() projects: (Project & { itProfiles: ClientITProfile[] })[];
  @Input() sapProfiles: any[];
  @Input() sarProfiles: any[];

  dialogRef: DynamicDialogRef | undefined;
  integrations: Integration[] | undefined;

  constructor(
    public dialogService: DialogService,
    public integrationsService: IntegrationsService,
    public alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.integrationsService.getAll().subscribe((integrations) => {
      this.integrations = integrations;
    });
  }

  ngOnDestroy(): void {
    this.dialogRef?.close();
  }

  editIntegration(item?: Integration) {
    const header = `${item ? 'Edit' : 'Add'} Integration${
      item ? ' - ' + item?.name : ''
    }`;

    this.dialogRef = this.dialogService.open(EditIntegrationAppComponent, {
      width: '80%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: true,
      data: {
        item,
        projects: this.projects,
        sapProfiles: this.sapProfiles,
        sarProfiles: this.sarProfiles,
      },
      header,
    });

    this.dialogRef.onClose.subscribe((data?: Integration) => {
      if (!data) {
        return;
      }

      this.alertService.clear();

      if (data.id) {
        this.integrationsService.update(data).subscribe({
          next: (response) => {
            const index = this.integrations.findIndex(
              (i) => i.id === response.id
            );

            this.integrations = [
              ...this.integrations.slice(0, index),
              response,
              ...this.integrations.slice(index + 1),
            ];
          },
          error: (error) => {
            this.alertService.error(error?.message ?? error);
          },
        });
      } else {
        this.integrationsService.add(data).subscribe({
          next: (item) => {
            this.integrations.push(item);
          },
          error: (error) => {
            this.alertService.error(error?.message ?? error);
          },
        });
      }
    });
  }

  deleteIntegration(item: Integration) {
    this.integrationsService.delete(item.id).subscribe((i) => {
      this.integrations = this.integrations.filter((i) => i.id !== item.id);
    });
  }

  test(item: Integration) {
    this.alertService.clear();

    this.integrationsService.test(item).subscribe({
      next: () => {
        this.integrationsService.getById(item.id).subscribe({
          next: (data) => {
            const index = this.integrations.findIndex((i) => i.id === data.id);

            this.integrations = [
              ...this.integrations.slice(0, index),
              data,
              ...this.integrations.slice(index + 1),
            ];
          },
          error: (error) => this.alertService.error(error?.message ?? error),
        });
      },
      error: (error) => this.alertService.error(error?.message ?? error),
    });
  }
}
